// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6225) return "wp-content/assets/js/pages/attraction/6225.js";
	if (chunkId === 7870) return "wp-content/assets/js/pages/attraction/7870.js";
	if (chunkId === 1596) return "wp-content/assets/js/pages/attraction/1596.js";
	if (chunkId === 5298) return "wp-content/assets/js/pages/attraction/5298.js";
	if (chunkId === 6716) return "wp-content/assets/js/pages/attraction/6716.js";
	if (chunkId === 5476) return "wp-content/assets/js/pages/attraction/5476.js";
	if (chunkId === 4067) return "wp-content/assets/js/pages/attraction/4067.js";
	if (chunkId === 3023) return "wp-content/assets/js/pages/attraction/3023.js";
	// return url for filenames based on template
	return undefined;
};